import { useContractsData } from '@/hooks/api/use-contracts';
import { hasContractApporteur43397 } from '@/lib/contracts';

/** Marque à afficher : APRIL Moto dès qu'un contrat est apporté par APRIL Moto (43397). */
const useBrandName = (): 'APRIL Moto' | 'AM Gestion' => {
    const contracts = useContractsData();
    return hasContractApporteur43397(contracts) ? 'APRIL Moto' : 'AM Gestion';
};

export default useBrandName;
